import css from './EnumList.css'